import React, { Component } from 'react'
import { connect } from 'react-redux'

import BkFlowRestaurantsCard from './elements/BkFlowRestaurantsCard'

import yn from 'yn'

if (yn(process.env.REACT_APP_COMPONENT_ENABLE_RESTAURANT_RESERVATIONS)) {
  require('../../styles/css/components/restaurants/bk-flow-restaurants-cards.css')
}
class BkFlowRestaurantsCards extends Component {

  constructor(props) {
    super(props)

    this.state = {
    }
  }

  render() {
    const {
      configData,
      activeStep,
      restaurantData,
      activeRoom,
      handleContinuePayment,
    } = this.props

    let restaurantCards = []
    const restaurantCardType = restaurantData.restaurants

    // Construct cards, groups and accordions if data meets requirements
    for (let restaurantKey in restaurantCardType) {
      if (
        restaurantCardType[restaurantKey].id &&
        restaurantCardType[restaurantKey].serviceDetails &&
        restaurantCardType[restaurantKey].serviceDetails.comments
      ) {
        restaurantCards.push(
          <BkFlowRestaurantsCard
            key={ 'restaurant-' + restaurantCardType[restaurantKey].id }
            configData={ configData }
            activeStep={ activeStep }
            restaurantCardType={ restaurantCardType }
            restaurantKey={ restaurantKey }
            activeRoom={ activeRoom }
            handleContinuePayment={ handleContinuePayment }
          />
        )
      }
    }

    // Render all restaurant groups with cards or generic no-avail response
    return (
     <div className="bk-flow-restaurants">
       <div className="bk-flow-restaurants__cards row center-xs">
        { restaurantCards }
       </div>
     </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    configData: state.configData.configuration,
    restaurantData: state.restaurantData,
    availabilityData: state.availabilityData,
    activeRoom: state.activeRoomData,
  }
}

export default connect(mapStateToProps, null)(BkFlowRestaurantsCards)



// WEBPACK FOOTER //
// ./src/components/restaurants/BkFlowRestaurantsCards.js